import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { normalizePremiumFolderData } from '../../../../../../utils/normalizePremiumFolderData';
import Button from '../../../../../../Button';
import PointsIcon from '@wix/da-ds/pkg/Icons/Points';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { BiData, BiContextProvidedValue, } from '@wix/da-bi/pkg/events';
import { ThemeOverride, ThemeOptions, } from '@wix/da-react-context/pkg/ThemeContext';
import { getDeviationResourceType, getDeviationType, } from '../../../../../_helpers';
import { DeviationTypes } from '../../../../../../types/deviation';
import thumbPaywallStyles from './ThumbPaywall.scss';
var unlockHint = function (type, isMobile) {
    if (type === DeviationTypes.FILM) {
        return isMobile
            ? 'deviationview.overlay.premiumFolder.unlockHint.pay.mobile.video'
            : 'deviationview.overlay.premiumFolder.unlockHint.pay.video';
    }
    return isMobile
        ? 'deviationview.overlay.premiumFolder.unlockHint.pay.mobile'
        : 'deviationview.overlay.premiumFolder.unlockHint.pay';
};
var PaidThumbPaywall = function (_a) {
    var _b;
    var deviation = _a.deviation, isSmall = _a.isSmall, className = _a.className;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var _c = normalizePremiumFolderData(deviation === null || deviation === void 0 ? void 0 : deviation.premiumFolderData), pointPrice = _c.pointPrice, folderId = _c.folderId, subproductId = _c.subproductId, formattedDollarPrice = _c.formattedDollarPrice;
    var isLiterature = getDeviationType(deviation) === 'literature';
    return (React.createElement("div", { className: classnames(thumbPaywallStyles['root'], isSmall && thumbPaywallStyles['small'], className) },
        React.createElement("div", { className: thumbPaywallStyles['label'] }, t(unlockHint(getDeviationType(deviation), isMobile))),
        React.createElement(ThemeOverride, { theme: ThemeOptions.DARK },
            React.createElement(Button, { view: "b18", height: "medium", className: classnames(thumbPaywallStyles['button'], isLiterature && thumbPaywallStyles['button-on-literature']), biData: BiData({
                    evid: 361,
                    typeid: getDeviationResourceType(deviation),
                    itemid: deviation.deviationId,
                    authorid: (_b = deviation.author) === null || _b === void 0 ? void 0 : _b.useridUuid,
                    galleryid: folderId !== null && folderId !== void 0 ? folderId : 0,
                    points: pointPrice,
                    rank: BiContextProvidedValue,
                    reason_shown: BiContextProvidedValue,
                    section_typeid: BiContextProvidedValue,
                    sectionid: BiContextProvidedValue,
                    sectionname: BiContextProvidedValue,
                    sectionrank: BiContextProvidedValue,
                    sectiontype: BiContextProvidedValue,
                    sort_type: BiContextProvidedValue,
                    widgetname: BiContextProvidedValue,
                }), href: subproductId ? Url.checkoutLink(subproductId) : undefined }, isSmall
                ? t('deviationview.overlay.premiumFolder.button.pay.short')
                : isMobile || pointPrice === undefined || pointPrice < 80
                    ? t('deviationview.overlay.premiumFolder.button.pay.mobile', {
                        dollarPrice: formattedDollarPrice,
                    })
                    : t('deviationview.overlay.premiumFolder.button.pay', {
                        postProcess: 'reactPostprocessor',
                        dollarPrice: formattedDollarPrice,
                        pointPrice: pointPrice,
                        pointsIcon: (React.createElement(PointsIcon, { className: thumbPaywallStyles['points-icon'], size: IconSize.TINY, disableDefaultColors: true })),
                    })))));
};
PaidThumbPaywall.displayName = 'PaidThumbPaywall';
export default PaidThumbPaywall;
//# sourceMappingURL=PaidThumbPaywall.js.map